import { Component,  OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Select, Store } from '@ngxs/store';
import { DesktopStorageService } from '../services/storage.service';
import { AuthGuardedPage } from '../authGuardedPage';
import { DesktopErrorHandler } from '../services/errorHandler.service';
import { MatDialog } from '@angular/material/dialog';
import { CommonService, Patient, PatientAlert, PatientPage, Provider, Time, GetPageOfPatients, Log, PractitionerGroupEntity, GetTeamsForUser, ClearPatientSearchList, sanitizeIdentifier} from 'huddyapi';
import { Observable, Subscription } from 'rxjs';
import { DomSanitizer } from "@angular/platform-browser";
import { MatIconRegistry } from "@angular/material/icon";
import { Filter } from '../components/patient-list-filter/filter';
import { EditPatientDialog } from '../components/edit-patient-dialog/edit-patient-dialog.component';
import { PatientListFilter } from '../components/patient-list-filter/patient-list-filter.component';

import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { AppComponent } from '../app.component';
import { CommunityConfigService, UserTeam } from '../services/community-config.service';


@Component({
  selector: 'app-patients',
  templateUrl: './patients.component.html',
  styleUrls: ['./patients.component.scss']
})
export class PatientsComponent extends AuthGuardedPage implements OnInit  {
  homePreferenceSubscription: Subscription;
  userSubscription: any;
  homePreference: string;
  saving: boolean;
  creating: boolean;
  user: any;
  patients : Patient[] = [];
  page : PatientPage;
  pageNum : number = 0;
  pageSize : number = 10;
  sort : string = 'alerts';
  sortDir : string = 'desc';
  loading : boolean =true;
  showTeamOnly : boolean = true;
  filters : Filter[] = [];
  searchField : string = '';
  executedSearchField : string = '';
  currentTeam : UserTeam ;
  @ViewChildren(PatientListFilter) filterComponents: QueryList<PatientListFilter>;
  displayedColumns : DisplayedColumn[] = [
    { "name" :  "identifier", "displayName" : "Identifier" },
    { "name" :  "friendlyName", "displayName" : "Name" },
    { "name" :  "conditions", "displayName" : "Conditions" },
    { "name" :  "tags", "displayName" : "Tags" },
    { "name" :  "address", "displayName" : "Address" },
    { "name" :  "phone", "displayName" : "Phone" },
    { "name" :  "familyIdentifiers", "displayName" : "Family Identifier" },
    { "name" :  "teams", "displayName" : "Teams" },
    { "name" :  "compasses", "displayName" : "Compasses" },
    { "name" :  "lastAssignedDt", "displayName" : "Last Assigned Dt" },
    { "name" :  "lastMeasurement", "displayName" : "Last Log Dt" },
    { "name" :  "lastAssessmentDt", "displayName" : "Last Assessment Dt" },
    { "name" :  "alerts", "displayName" : "Alerts" }
  ];



  
  selectedColumns : string[] = [
    "identifier",
    "friendlyName",
    "conditions",
    "tags",
    "teams",
    "address",
    "familyIdentifiers",
    "alerts"
  ];
  public displayColumnsForm : UntypedFormGroup;
  @Select(state => state.patientState.currentPage) patients$: Observable<PatientPage>;
  patientSubscription: Subscription;
  providerSubscription: Subscription;
  providers: Provider[];
  @Select(state => state.compassState.providers) providers$: Observable<Provider[]>;
  @Select(state => state.practitionerGroupState.userTeams) teams$: Observable<PractitionerGroupEntity[]>;

  constructor(
    private errorHandler: DesktopErrorHandler,
    public commonService : CommonService,
    public store : Store,
    public route: ActivatedRoute,
    public fb : UntypedFormBuilder,
    public storageService: DesktopStorageService,
    public router: Router,
    public dialog: MatDialog,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    super(commonService);
    this.logout(this, true);
    CommonService.onboardingPersona = null;
    this.saving = false;
    this.creating = null;
    this.matIconRegistry.addSvgIcon('search',  domSanitizer.bypassSecurityTrustResourceUrl('./assets/content-icon/ic-02.svg'));
    this.matIconRegistry.addSvgIcon('red',  domSanitizer.bypassSecurityTrustResourceUrl('./assets/red_alert.svg'));
    this.matIconRegistry.addSvgIcon('yellow',  domSanitizer.bypassSecurityTrustResourceUrl('./assets/yellow_alert.svg'));
    this.matIconRegistry.addSvgIcon('green',  domSanitizer.bypassSecurityTrustResourceUrl('./assets/green_alert.svg'));
    this.filters = [];
    this.filters.push (new Filter());
    this.filters[this.filters.length -1].index = 0;
  

  }
  ngOnInit(): void {
    this.store.dispatch(new ClearPatientSearchList());
    this.userSubscription = this.commonService.getUserSubject().subscribe((user: any) => {
      this.user = user || '';
      this.store.dispatch(new GetTeamsForUser())
    });

    this.displayColumnsForm = this.fb.group({
      selectedColumns: []
     });
    this.displayColumnsForm.controls['selectedColumns'].setValue(this.selectedColumns);
    this.patientSubscription = this.patients$.subscribe((patientPage: PatientPage) => {
      // console.error('GOT PATIENTS', patientPage);
        this.patients = [];
        this.page = patientPage;
        if (patientPage && patientPage.content) {
          this.patients = this.patients.concat(patientPage?.content);
          // for (let p of this.patients) {
          //   console.log(p.username + ': ' + p.lastAssignedDt + ' ' + this.formatDate(p.lastAssignedDt));
          // }
          this.loading = false;
        }
        Log.logClassLevel(0, 'HOME', 'patients', this.patients, this.page);
        this.providerSubscription = this.providers$.subscribe((providers: Provider[]) => {
          this.providers = providers;
          const providerName =  { "name" :  "providerName", "displayName" : "Provider Name" }
          if (this.isMultiProvider() && this.displayedColumns.map(c => c.name).indexOf("providerName") === -1) {
            this.displayedColumns.splice(2, 0,  providerName);
          }
        });
    });
    this.getPageOfPatients();
  }


  ngOnDestroy(): void {
    this.homePreferenceSubscription?.unsubscribe();
    if(this.userSubscription?.unsubscribe)
      this.userSubscription.unsubscribe();
    if(this.patientSubscription?.unsubscribe)
      this.patientSubscription.unsubscribe();
    this.providerSubscription.unsubscribe();  
  }


  setCreating(creating: boolean) {
    if(!this.saving)
      this.creating = creating;
  }


  cleanupIdentifier(patient : Patient) {
    if (patient.familyIdentifiers && patient.identifier && patient.identifier.length > 6) {
      const familyIdentifiers : string[] = patient.familyIdentifiers.split(',');
      let firstSix : string = patient.identifier.substring(0, 6);
      let familyIdentifier : string = familyIdentifiers.find(fid => fid.startsWith(firstSix));
      if (familyIdentifier) {
        return sanitizeIdentifier(familyIdentifier, patient.identifier);
      }
    }
    return '';
  }

  cleanupFamilyIdentifier(familyIdentifier : string) {
    return sanitizeIdentifier(familyIdentifier, familyIdentifier);
  }


  getUserName() : string {

    let ret = '';
    if (this.user)
     ret = this.getName(this.user);
    return ret;
  }

  getName(user: any) {
    if(!user)
      return;
    if(user.firstName && user.lastName)
      return user.firstName + ' ' + user.lastName;
    return this.getShortName(user);
  }

  getShortName(user: any) {
    if(!user)
      return;
    if(user.firstName)
      return user.firstName;
    if(user.lastName)
      return user.lastName;
    if (user.email) {
        let index = user.email.indexOf('@');
        return index < 0 ? user.email : user.email.substring(0, index);
    }
    return "";
  }


  getAlertIcon(patientAlert : PatientAlert) : string {
    return   patientAlert.icon.toLowerCase() ;
  }

  getAlertTooltip(patientAlert : PatientAlert) : string {
    let d = new Date(0);
    d.setUTCSeconds(patientAlert.epochTimeSecs);
    let ret : string =  patientAlert.text + ' (' + new Time(d.toISOString()).getDateDisplay() + ')';
    return ret;
  }

  formatDate(dateStr : string) {
    return (dateStr) ? new Time(dateStr).getDateDisplay() : '-';
  }

  formatDateNoTZAdjustment(dateStr : string) {
    if (!dateStr) {
      return '-';
    }
    let idx : number = dateStr.indexOf('T');
    if (idx > -1) {
      return this.formatDate(dateStr.substring(0, idx));
    }
    return dateStr;
  }

  getNumberOfPatients() : number {
    if (this.page) {
      return this.page.totalElements;
    }
  }

  pagePatientList($event) {
    if (this.pageSize === $event.pageSize) {
      this.pageNum = $event.pageIndex;
    } else {
      this.pageNum = 0;
    }
    this.pageSize = $event.pageSize;
    this.getPageOfPatients();
  }

  changeSort($event) {
    //this.loading = true;
    this.sort = $event.active;
    this.sortDir = $event.direction;
    this.getPageOfPatients();
  }

  getProviderName(patient : Patient) : string {
    if (this.providers && this.providers.length > 1 ) {
      let names : string[] = this.providers.filter(p => p.name === patient.providerName).map(p => p.name);
      if (names.length > 0) {
        return  names[0] ;
      }
    }
    return '';
  }

  isMultiProvider() : boolean {
    return this.providers && this.providers.length > 1;
  }

  getPageOfPatients() {
    this.loading = true;
    let filterStr : string = '';
    for (let filter of this.filters) {
      if (filter.columnValue && filter.operatorValue) {
      filterStr = filterStr +  filter.columnValue + filter.operatorValue + filter.expressionValue + '*';
      }
    }
    let teamsArr : string [] =  [];
    
    // console.error('GET PAGE OF PATIENTS');
    this.store.dispatch(new GetPageOfPatients(this.pageNum, this.pageSize, filterStr, this.executedSearchField, this.sort, this.sortDir, teamsArr))
  }

  addFilter() {
    if (this.filters.length < 3) {
      this.filters.push(new Filter());
      this.filters[this.filters.length -1].index = this.filters.length -1;
    }
  }

  onFilterEdit() {
    this.pageNum = 0;
    this.searchField = '';
    this.executedSearchField = '';
    for (let filterComponent of this.filterComponents) {
      filterComponent.updateFilterFromEdited();
    }
    this.getPageOfPatients();
  }

  onRemoveFilter($event) {
    console.log($event);
    if (this.filters.length > 1) {
      this.filters.splice($event.index,  1);
      let index : number = 0;
      for (let filter of this.filters) {
        filter.index = index++;
      } 
    } else if (this.filters.length === 1) {
      this.filters[0].columnValue = '';
      this.filters[0].expressionValue = '';
      this.filters[0].operatorValue = '';
    } else {
      $event.clear();
    }
    this.getPageOfPatients();
  }

  search($event) {
    this.filters = [];
    this.filters.push(new Filter());
    this.filters[this.filters.length -1].index = 0;
     
    if (this.filterComponents) {
      for (let listFilter of this.filterComponents) {
        listFilter.clear();
      }
    }
    this.pageNum = 0;
    console.log($event,this.searchField, $event.target.value);
    this.executedSearchField = this.searchField;
    this.getPageOfPatients();
  } 

  clearSearchField() {
    this.searchField = '';
    this.executedSearchField = '';
    this.getPageOfPatients();
  }

  addPatient() {
    this.dialog.open(EditPatientDialog, {
      width: '600px',
      height: '575px',
      data: {
        fromFamily: false,
        patient: {}
      }
    });
  }

  getPageNumber() : number {
    let ret : number = 0;
    if (this.page) {
      ret = this.page.number;
    }
    return ret;
  }

  getPatientName(patient : Patient) : string {
    let ret : string = patient.friendlyName;
    if (!ret || ret.indexOf("null ") > -1) {
      ret = patient.username;
    }
    return ret;
  }
  
  checkSearchValue($event) {
    this.searchField = this.searchField.replace(/[^a-zA-Z0-9 '-.]/g, '');
  }

  onClickPatient(patient : Patient, field : string) {
    this.router.navigateByUrl('/patient/' + patient.id);
  }

  onClickFamilyIdentifier(patient : Patient, identifier : string) {
      const familyIdentifiers : string[] = this.getFamilyIdentifiers(patient);
      const idx : number = familyIdentifiers.indexOf(identifier);
      if (idx > -1 && idx < patient.familyIds.length) {
        this.router.navigateByUrl('/family/' + patient.familyIds[idx]);
      }
    
  }

  getFamilyIdentifiers(patient : Patient) : string[] {
    return patient.familyIdentifiers ? patient.familyIdentifiers.split(',') : [];
  }

  isCommunity() : boolean {
    return CommunityConfigService.isCommunity;
  }


}

export interface DisplayedColumn {
  displayName : string;
  name : string;
}